<template>
  <v-container>
    <h2>Biz Customer Information</h2>
    <v-row>
      <v-col lg="10" md="12" xs="12">
        <v-row>
          <v-col
            cols="4"
            md="2"
          >
            <p>Company name:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ biz_customer.company_name || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Remark:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ biz_customer.remark || '-' }}</p>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'biz-customer-list' }"
          >
            Back
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "BizCustomerView",
  components: { },
  data: () => ({
    biz_customer_id: null,
    biz_customer: {
      company_name: null,
      remark: null
    },
  }),
  async mounted () {
    let id = this.$route.params.id
    await this.getBizCustomer(id)
  },
  methods: {
    async getBizCustomer (id) {
      this.biz_customer_id = id
      try {
        const result = await this.$http.get(`/back-office/biz-customers/${this.biz_customer_id}`, authHeader())
        console.log(result)
        this.biz_customer.company_name = result.data.company_name
        this.biz_customer.remark = result.data.remark
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      return true
    }
  },
};
</script>
